import { render, staticRenderFns } from "./rightsmadiolg.vue?vue&type=template&id=9092caf4&scoped=true"
import script from "./rightsmadiolg.vue?vue&type=script&lang=js"
export * from "./rightsmadiolg.vue?vue&type=script&lang=js"
import style0 from "./rightsmadiolg.vue?vue&type=style&index=0&id=9092caf4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9092caf4",
  null
  
)

export default component.exports